import * as React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import fetch from 'isomorphic-fetch';

// Components
import Content from './Content';

// Assets
import { brandColors, fonts } from '../../styles/variables';
import { updateField, resetForm } from '../../store/ContactForm/actions';

const ContentStyled = styled(Content)`
  display: block;
  margin: 60px 0;
`;

const SendLink = styled.div`
  color: ${brandColors.orange};
  cursor: pointer;
  font-family: ${fonts.monterrat};
  font-size: 36px;
  font-weight: bold;
  line-height: 42px;
  -webkit-transition: 0.5s;
  -moz-transition: 0.5s;
  -o-transition: 0.5s;
  transition: 0.5s;
  opacity: 1;
  z-index: 5;
  position: relative;
  &.fade {
    -webkit-transition: 0.5s;
    -moz-transition: 0.5s;
    -o-transition: 0.5s;
    transition: 0.5s;
    opacity: 0;
    visibility: hidden;
  }
`;

const SendContainer = styled.div`
  * {
    float: left;
    margin-right: 50px;
  }
`;

const FormWrapper = styled.div`
  width: 100%;
  max-width: 360px;
  min-width: 212px;
  margin-left: 40px;

  p {
    ${({ color }) => `
      color: ${color};
    `};
    font-family: ${fonts.athelas};
    font-size: 18px;
    font-style: italic;
    letter-spacing: 1px;
    line-height: 44px;
    float: right;
    margin: 0;
  }
`;

const SvgTick = styled.svg`
  enable-background: new 0 0 37 37;
  height: 100px;
  left: 0px;
  position: absolute;
  width: 100px;
  margin-top: -26px;
  z-index: 4;
  opacity: 0;
  &.fade {
    opacity: 1;
  }
`;

const PolyTick = styled.polyline`
  fill: none;
  stroke: #228b22;
  stroke-width: 3;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  stroke-dasharray: 50;
  stroke-dashoffset: 50;
  -webkit-transition: stroke-dashoffset 1s 0.5s ease-out;
  -moz-transition: stroke-dashoffset 1s 0.5s ease-out;
  -ms-transition: stroke-dashoffset 1s 0.5s ease-out;
  -o-transition: stroke-dashoffset 1s 0.5s ease-out;
  transition: stroke-dashoffset 1s 0.5s ease-out;
  &.fade {
    stroke-dashoffset: 0;
  }
`;

function Tick(props) {
  const { tickFade } = props;
  return (
    <SvgTick
      className={tickFade ? 'fade' : ''}
      version="1.1"
      id="tick"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 37 37"
      xmlSpace="preserve"
    >
      <PolyTick className={tickFade ? 'fade' : ''} points="11.6,20 15.9,24.2 26.4,13.8" />
    </SvgTick>
  );
}

Tick.propTypes = {
  tickFade: PropTypes.bool.isRequired
};

class ContactForm extends React.PureComponent {
  state = { fade: false, sending: false };

  componentDidMount() {
    const { resetStoreValue } = this.props;
    resetStoreValue();
  }

  send = form => {
    const { fields, updateStoreValue, resetStoreValue } = this.props;
    const { sending } = this.state;
    if (sending) {
      return;
    }
    this.setState({ sending: true });

    const data = new FormData();
    Object.keys(fields).map(name => data.append(name, fields[name].value));
    data.append('form', form);

    fetch('https://radical-departures.com/api/', {
      method: 'POST',
      body: data
    }).then(response =>
      response.json().then(results => {
        if (results.sent) {
          this.setState({ fade: true });

          setTimeout(() => {
            this.setState({ fade: false });
            resetStoreValue();
            this.setState({ sending: false });
          }, 3000);
        } else if (results.errors) {
          Object.keys(results.errors).forEach(error => {
            updateStoreValue({ name: error, error: results.errors[error], form });
          });

          this.setState({ sending: false });
          this.forceUpdate();
        }
      })
    );
  };

  render() {
    const { children, color, form } = this.props;
    const { fade } = this.state;

    return (
      <FormWrapper color={color}>
        <ContentStyled>
          {children.map((child, index) =>
            React.cloneElement(child, {
              key: index,
              color,
              form
            })
          )}
        </ContentStyled>

        <SendContainer>
          <SendLink onClick={() => this.send(form)} className={fade ? 'fade' : ''}>
            send
          </SendLink>
          <Tick tickFade={fade} />
          <p>*required field</p>
        </SendContainer>
      </FormWrapper>
    );
  }
}

ContactForm.defaultProps = {
  color: brandColors.white,
  fade: false
};

ContactForm.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  form: PropTypes.string.isRequired,
  fade: PropTypes.bool,
  updateStoreValue: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  resetStoreValue: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => ({
  fields: state.contactForm.forms[ownProps.form].fields
});

const mapDispatchToProps = dispatch => ({
  updateStoreValue(value) {
    dispatch(updateField(value));
  },
  resetStoreValue(value) {
    dispatch(resetForm(value));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactForm);



// WEBPACK FOOTER //
// ./src/components/ContactForm/index.jsx